import React, { useEffect, useState } from "react";
import { MdOutlineArrowBackIosNew as LBtn, MdOutlineArrowForwardIos as RBtn } from 'react-icons/md';
import { FiMoreHorizontal as MoreIcon } from 'react-icons/fi';
import tableStyle from '../css/table.module.css';
import SettingsModal from '../Modal/settingsCustomModal';
import UpdateLga from "./UpdateLga";

interface State {
  StateId: number;
  StateName: string;
  CountryId?: number;
  Country: StateCountry;
}

interface StateCountry {
  CountryId: number;
  CountryName: string;
  Id: number;
  CreatedBy?: any;
  ModifiedBy?: any;
  UserIpAddress?: any;
  CreateDate: string;
  LastModified: string;
  ActiveStatus: boolean;
  IsApprovalRequired?: any;
  RouteId?: any;
  ApprovalTypeId?: any;
  IsDeleted: boolean;
}

interface Lga {
    LGAId: number;
    LGAName: string;
    StateId: number;
    State: LgaState;
}
  
interface LgaState {
    StateId: number;
    StateName: string;
    CountryId: number;
    Country?: any;
    Id: number;
    CreatedBy?: any;
    ModifiedBy?: any;
    UserIpAddress?: any;
    CreateDate: string;
    LastModified: string;
    ActiveStatus: boolean;
    IsApprovalRequired?: any;
    RouteId?: any;
    ApprovalTypeId?: any;
    IsDeleted: boolean;
}

interface ComponentProps {
    getLgaQuery: Lga[] | undefined;
    getStateData: State[] | undefined;
    stateIsLoading: boolean;
    stateIsError: boolean;
    getStateErrorMessage: string;
}

const LgaTable: React.FC<ComponentProps> = ({ getLgaQuery, getStateData, stateIsError, stateIsLoading, getStateErrorMessage }) => {
    const [activeData, setActiveData] = useState<any>([]);
    const [pageData, setPageData] = useState<any>([]);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [pageArr, setPageArr] = useState<any>([]);
    const [showMore, setShowMore] = useState<boolean>(false);
    const [showIndex, setShowIndex] = useState<any>(null);
    const [showSpan, setShowSpan] = useState<boolean>(false);
    const [spanIndex, setSpanIndex] = useState<null | number>(null);
    const [stateId, setStateId] = useState(0);
    const [lgaId, setLgaId] = useState(0);
    const [lgaName, setLgaName] = useState('');
    const [openUpdateLGAModal, setOpenUpdateLGAModal] = useState(false);
    const [openDeleteLGAModal, setOpenDeleteLGAModal] = useState(false);

    const handleOpenUpdateLGAModal = () => setOpenUpdateLGAModal(true);
    const handleCloseUpdateLGAModal = () => setOpenUpdateLGAModal(false);

    const handleOpenDeleteLGAModal = () => setOpenDeleteLGAModal(true);
    const handleCloseDeleteLGAModal = () => setOpenDeleteLGAModal(false);

    const DATA_PER_PAGE = 10;

    const handlePrevous = () =>{
        if(currentPage === 0){
            if(pageArr.length > 1){
                setCurrentPage(pageArr.at(-1))
                return false;
            }
            setCurrentPage(0);
            return false;

        }
        setCurrentPage(currentPage-1);
    }

    const handleNext = ()=>{
        if(pageArr.length > 1){
            if(currentPage === pageArr.at(-1)){
                setCurrentPage(0);
                return false;
            }
            setCurrentPage(currentPage+1);
            return false;
        }
        setCurrentPage(0);
    }

    const handleMore = (index: number) => {
        if(index == showIndex){
            setShowIndex(null);
            setShowMore(false);
            return
        }
        setShowIndex(index);
        setShowMore(true);
    }

    const handleSpan = (index: number) => {
        if(index == spanIndex){
            setSpanIndex(null);
            setShowSpan(false);
            return
        }
        setSpanIndex(index);
        setShowSpan(true);
    }

    const handleUpdate = (data: Lga) => {
        setStateId(data?.State?.StateId);
        setLgaName(data?.LGAName);
        setLgaId(data?.LGAId)
        handleOpenUpdateLGAModal();
    }

    const handleDelete = (data: Lga) => {
        // setStateId(data?.StateId);
        // setStateName(data?.StateName);
        // setCountryId(data?.Country?.CountryId)
        // handleOpenDeleteStateModal();
    }

    const data = getLgaQuery;

    useEffect(() => {
        if(data && data?.length > 0){
            setActiveData(data);
            let lastPage = Math.ceil(data?.length / 10);
            let i = 0;
            let arr = [];

            for(i = 0; i < lastPage; i++){
                arr.push(i);
            }

            setPageArr(arr);
            setPageData(data?.slice(0, DATA_PER_PAGE));
    
        }
    },[data])

    useEffect(() => {
        if(activeData && activeData.length > 0){    
            let start = currentPage * DATA_PER_PAGE;
            let stop = start + DATA_PER_PAGE;
            setPageData(data?.slice(start, stop));  
        }
    },[currentPage])

    const getCountryName = (countryId: number) => {
        const countryName = getStateData?.find((data) => {
            return data?.CountryId === countryId ? data?.Country?.CountryName : ''
        })
        return countryName?.Country?.CountryName
    }

    return (
        <div className={tableStyle.container}>
            <>
                <div style={{gridTemplateColumns:`repeat(4, 2.3fr) 0.2fr`}}>
                    <div>State</div>
                    <div>Country</div>
                    <div>Local Government Area</div>
                    <div>Status</div>
                </div>
                <div>  
                   { 
                        pageData && pageData.length > 0 && pageData.map(( data: Lga, index: number) =>
                        <div key={index} style={{gridTemplateColumns:`repeat(4, 2.3fr) 0.2fr`}}>
                            <div onClick={()=>handleSpan(index)}>{data?.State?.StateName}</div>
                            <div onClick={()=>handleSpan(index)}>{getCountryName(data?.State?.CountryId)}</div>
                            <div onClick={()=>handleSpan(index)}>{data?.LGAName}</div>
                            <div onClick={()=>handleSpan(index)}>{data?.State.IsDeleted === false ? 'Active' : 'Disabled'}</div>
                            <div> 
                                <span 
                                    className={`${tableStyle.moreSpan} ${index == showIndex ? `${tableStyle.activeMore}` : ''} `} 
                                    onClick={()=>handleMore(index)}
                                >
                                    <MoreIcon />
                                    {index == showIndex && showMore ? (
                                    <div>
                                        <div onClick={() => handleUpdate(data)}>Edit State</div>
                                        {/* <div onClick={() => handleDelete(data)}>Delete State</div> */}
                                    </div>) : '' }
                                </span>
                            </div>
                        </div>
                    )}
                </div>
                <div className={tableStyle.pagination}>
                    <div>
                        <button onClick={handlePrevous} className={`${tableStyle.lBtn} ${tableStyle.btn}`}><LBtn/></button>
                        {pageArr && pageArr.length > 0 && pageArr.map((ePage: number, index: number) => {

                            if(index <= 4 && currentPage <= 4) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == currentPage ) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index >= pageArr.length - 3 && currentPage >= pageArr.length -3) return (<span
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                            >
                                {ePage + 1}
                            </span>)  

                            if(index == pageArr.length-1 && pageArr?.length > 5) return (
                            <>
                                <>...</>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                            </>
                            )  

                            if(index == 0 && pageArr?.length > 5) return (
                            <>
                                <span 
                                style={ ePage == currentPage ? {backgroundColor : "var(--activeP-back)", color : "var(--white-color)"} : {} } 
                                key={ePage} 
                                onClick={() => setCurrentPage(ePage)}
                                >
                                    {ePage + 1}
                                </span>
                                <>...</>
                            </>)  

                        })} 
                        <button onClick={handleNext} className={`${tableStyle.rBtn} ${tableStyle.btn}`}><RBtn/></button>
                    </div>
                </div>
            </>

            <SettingsModal
                open={openUpdateLGAModal}
                cancel={handleCloseUpdateLGAModal}
                maxWidth='480px'
                header='Update Local Government Area'
                showrightIcon={false}
                content={<UpdateLga 
                    stateId={stateId} 
                    handleClose={handleCloseUpdateLGAModal} 
                    lgaName={lgaName}
                    data={getStateData}
                    isLoading={stateIsLoading}
                    isError={stateIsError}
                    errorMessage={getStateErrorMessage}
                />}   
            />

            {/* <SettingsModal
                open={openDeleteStateModal}
                cancel={handleCloseDeleteStateModal}
                maxWidth='653px'
                header='Delete Country'
                showrightIcon={false}
                content={<DeleteState 
                    countryId={countryId} 
                    stateName={stateName}
                    stateId={stateId}
                    handleClose={handleCloseDeleteStateModal}
                />}   
            />  */}
            
        </div>
    )
}

export default LgaTable;

